
<template>
  <div class="modal modal-blur fade" id="modal-show-overlapping" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Overlapping Screenshots</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z"/><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
          </button>
        </div>
        <div class="modal-body">
          <h2>You have overlapping screenshots. Two screenshots have been taken during the same month for the same keyword.</h2>
          <ul>
            <li v-for="screenshot in overlappingScreenshots">{{screenshot.keyword}} (Month: {{screenshot.keywordMonth}}) - {{screenshot.searchType}} Page {{screenshot.page}}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
  import WebLLCRESTApi from "../api/api";
  export default {
    data() {
      return {
      }
    },
    
    props: {
      overlappingScreenshots: Array
    },
    
    methods: {
      
    }
    
   

  }
</script>



// WEBPACK FOOTER //
// src/components/OverlappingScreenshotDlg.vue